module.exports = __webpack_public_path__ + "assets/devices/KP-250-af4aed15a4edcd11933f0980a14a4ad8.svg";